module.exports = "/_next/static/images/game-1-phone-attachment-lillies-76738d04e68641ea69be1f8c17d7daec.jpg";